import React, { Component } from 'react';
import './Replaceorder.css';
import NabarClient from '../../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import MapsNewOrder from '../../Components/Maps/MapsNewOrder';
import searchbule from '../../../image/searchbule.svg'
import iconrightwhite from '../../../image/iconrightwhite.svg'
import axios from 'axios'
import HandleRes from '../Components/HandleRes/HandleRes';
import { LinkAPI } from '../../../API/API';
import arrow from '../../../image/arrow.svg'


class ReplaceorderAR extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            categories:[],
            clients:[],
            receiver: "", 
            phone: "",
            coordinates:[],
            address_name:"",
            deliverynote: "",
            amount: 0,
            dropoffaddress_alias:"",
            orderPrice:50,
            totalPrice:50,
            categoryselectError: "",
            receiverError: "",
            phoneError: "",
            dropoffaddress_nameError:"",
            dropoffaddress_aliasError:"",
            startDate: new Date()


        };
        this.handleChange = this.handleChange.bind(this);
this.getclients()
    }
    handleChangedate(date) {
        this.setState({
          startDate: date
        });
      }
   
      getclients = () => {
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/getclients`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                clients: res.data.businessOwner.clients,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError: false,
            })
        }).catch(error => {
            this.HandleError(error)
        })
    }
    setStateFieldsReceiver = (object) => e => {

        this.setState({
            objectaddress_name:  object.name,
            receiver: object.name,
            phone: object.phone.replace(/^20+/, ''),
            address_name: object.location.address_name,
            dropoffaddress_alias: object.location.address_alias,
            coordinates: object.location.location.coordinates,

        })
     
    }
    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            localStorage.removeItem("userToken")
            window.location.replace("/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }
handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
        [event.target.name]: isCheckbox
            ? event.target.checked
            : event.target.value
    });

};
handleChangecheckbox = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
        [event.target.name]: isCheckbox
            ? event.target.checked
            : event.target.value,
            amount:0
    });

};
setStatecoordinatesaddress_alias = (coordinates,address_name)  =>{
    this.setState({
        coordinates: coordinates,
        address_name: address_name

    })
}
    validate = () => {
        let receiverError = "";
        let phoneError = "";
        let dropoffaddress_nameError="";
        let dropoffaddress_aliasError=""; 
        let amountError="";
        if (isNaN(this.state.phone) || this.state.phone < 10) {
            phoneError = "write phone Numper ";
        }
        if (this.state.receiver.length < 2) {
            receiverError = "write receiver name";
        }
        if (this.state.address_name.length < 2||!isNaN(this.state.address_name)) {
            dropoffaddress_nameError ="select your location correct";
        }
        if (this.state.coordinates.length<1) {
            dropoffaddress_nameError ="select your location correct";
        }
        if (this.state.dropoffaddress_alias.length < 2||!isNaN(this.state.dropoffaddress_alias)) {
            dropoffaddress_aliasError = "write your Address correct";
        }
        if (this.state.collectMoney === true) {
            if (isNaN(this.state.amount) || this.state.amount < 1) {
                amountError =  "write weight correct";
            }
        }
        if ( phoneError || receiverError|| dropoffaddress_nameError || dropoffaddress_aliasError||amountError) {
            this.setState({  phoneError, receiverError,dropoffaddress_nameError,dropoffaddress_aliasError,amountError});
            return false;
        }
        return true;
    };


    handleReplaceOrder = event => {
        event.preventDefault();
        const {receiver,phone,address_name,dropoffaddress_alias,coordinates,deliverynote,amount}= this.state
        const Token =localStorage.getItem("userToken")
        const id = this.props.match.params.id
        const isValid = this.validate();
        if (isValid) {
            // clear form
            axios.put(`${LinkAPI}/api/businessowner/replaceorder/${id}`,{
                dropoffLocation:{
                     address_name:address_name,
                     address_alias:dropoffaddress_alias ,
                     location:{
                         coordinates:coordinates
                     }
                },reciver: {
                            name: receiver,
                            phone: 20+phone.replace(/^0+/, '')
                        },
                note:deliverynote,
                amount:amount
                
          },{
                headers:{
                  Authorization:`${Token}`
                }
              }
              ).then(res =>{
                const url = "/OrderDetail/"+id
                window.location.replace(url);
            }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    localStorage.removeItem("userToken")
                    window.location.replace("/SignIn");
                } else if (error.response.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext: error.response.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
        }
    };


    handleReplaceOrder = event => {
        event.preventDefault();
        const {receiver,phone,dropoffaddress_name,dropoffaddress_alias,dropoffcoordinates,deliverynote,amount}= this.state
        const Token =localStorage.getItem("userToken")
        const id = this.props.match.params.id
        const isValid = this.validate();
        if (isValid) {
            // clear form
            axios.put(`${LinkAPI}/api/businessowner/replaceorder/${id}`,{
                dropoffLocation:{
                     address_name:dropoffaddress_name,
                     address_alias:dropoffaddress_alias ,
                     location:{
                         coordinates:dropoffcoordinates
                     }
                },reciver: {
                            name: receiver,
                            phone: phone
                        },
                note:deliverynote,
                amount:amount
                
          },{
                headers:{
                  Authorization:`${Token}`,
                  lang:"ar"
                }
              }
              ).then(res =>{
                const url = "/AR/OrderDetail/"+id
                window.location.replace(url);
            }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    localStorage.removeItem("userToken")
                    window.location.replace("/SignIn");
                } else if (error.response.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext: error.response.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
        }
    };


    
    render() {
        document.title ="kayn | تبديل "; 
        document.getElementsByTagName("META")[1].content="كاين | تبديل";
        document.documentElement.lang = 'ar';
        return (
            <div>
                <div className="AppAR container-fluid px-0">
                    <div className="row   mx-0">
                        <div className="col-md-1 px-0 ">
                            <NabarClient />
                        </div>
                        <div className="client col-md-11 px-lg-5">
                            <HeaderTool />
                            <h3 className=" fontsize9 my-2">تبديل</h3>
                            <div className="CreateOrder  m-3 p-3 shadow rounded">
                                <form id="createorders">
                                    <div className="">
                                        
                                    

                                        
                                        {/* map */}

                                        <MapsNewOrder  key={this.state.objectaddress_name} state={this.state} setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} />
                     
                                        <div className="col-md-6 px-lg-5 my-5  text-center">
                                            <div className="form-group mb-2 p-0 search_div" id="pac-container">
                                                <img className="mr-1 img_input " src={searchbule} alt="search" />
                                                <input type="text" id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.state.dropoffaddress_nameError ? 'is-invalid' : '')}  placeholder="اختار عنوان" placeholder="DROP OFF LOCATION" name="dropoffaddress_name" value={this.state.dropoffaddress_name} onChange={this.handleChange}/>
                                                
                                            </div>
                                            <div className="mb-2" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.dropoffaddress_nameError}
                                                </div>
                                            <div id="map"></div>
                                            <div className="form-group col-12 text-left mt-2">
                                                <input type="text" className={"form-control badge-pill p-3 " + (this.state.dropoffaddress_aliasError ? 'is-invalid' : '')} placeholder="تفاصيل العنوان" name="dropoffaddress_alias" value={this.state.dropoffaddress_alias} onChange={this.handleChange} />
                                                <div className="mx-5 px-5" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.dropoffaddress_aliasError}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">

                                        <div className="col-md-4  my-3">
                                            <div className="form-group  ">
                                                <input type="text" className={"form-control badge-pill " + (this.state.receiverError ? 'is-invalid' : '')} placeholder="اسم العميل" name="receiver" value={this.state.receiver} onChange={this.handleChange} />
                                                <img className="mr-1 mt-1 img_input3 pointer" src={arrow} alt="arrow" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />

                                                <div className="dropdown-menu  dropdownmapmenu2 mt-2" aria-labelledby="dropdownMenuButton">

                                                    {this.state.clients.length>0?
                                                        this.state.clients.map((x, i) => (
                                                            <a className="dropdown-item pointer" key={i} onClick={this.setStateFieldsReceiver(x)}>{x.name}</a>
                                                        )):<p className="text-center">No Clients in (MyClients)</p>}
                                                </div>
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.receiverError}
                                                </div>
                                            </div>
                                            <div className="form-group  counter">
                                                <input type="number" className={"form-control badge-pill " + (this.state.phoneError ? 'is-invalid' : '')} placeholder="رقم الهاتف" name="phone" value={this.state.phone} onChange={this.handleChange} />
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.phoneError}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4  my-3">
                                            <div className="form-group  ">
                                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="ملاحظات"  name="deliverynote" value={this.state.deliverynote} onChange={this.handleChange}></textarea>

                                            </div>
                                        </div>

                                        <div className="col-md-4  my-3">
                                            <div className="form-check text-center mb-3">
                                                <input className="form-check-input" type="checkbox" id="gridCheck1" name="collectMoney" value={this.state.collectMoney} onChange={this.handleChangecheckbox} />
                                                <label className="form-check-label" htmlFor="gridCheck1">
                                                    Collect money from the receiver
                                        </label>
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.collectMoneyError}
                                                </div>
                                            </div>
                                            <div className="form-group  ">
                                                <input type="number" className={"form-control badge-pill" + (this.state.amountError ? ' is-invalid' : '')} placeholder="AMOUNT" name="amount" value={this.state.amount} onChange={this.handleChange}
                                                    disabled={(this.state.collectMoney ? '' : 'disabled')}
                                                />
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.amountError}
                                                </div>
                                            </div>
                                        </div>
                                        </div>

                                    </div>
                                    <hr />
                                    <div className="col-md-6 px-3 ">
                                             <p className="    fontsize11 font-weight-bold " >سعر الاسترجاع : <span className=" fontsize11 font-weight-bold  float-left">20 EGP</span></p>
                                    <p className=" mt-3 fontsize11 font-weight-bold " >السعر النهائي  : <span className=" fontsize11 font-weight-bold  float-left">70 EGP</span></p>
                                        </div> 
                                   <div className="text-center d-sm-flex justify-content-sm-around  flex-wrap my-3">
                                        <button type="submit" onClick={this.handleReplaceOrder} className="text-white badge-pill p-2 pl-1 px-3 my-1 border shadow bluebg "><img className="ml-1" src={iconrightwhite} alt="rightwhite" />تاكيد</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger"/> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger"/> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger"/> : '')}

            </div>
        )
    }
}


export default ReplaceorderAR;